import {isServer, useQuery} from '@tanstack/react-query'
import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {MRT_API_BASEPATH} from '../../ssr/constants'
import {useLocation} from 'react-router-dom'

const useAwinRef = () => {
    const location = useLocation()
    let awc = ''

    const urlParams = new URLSearchParams(location.search)
    awc = urlParams.get('awc') || ''
    awc = String(awc)

    const appOrigin = getAppOrigin()
    const shouldFetch = Boolean(awc) && !isServer
    return useQuery(
        ['useAwinRef', awc],
        async () => {
            const response = await fetch(
                `${appOrigin}${MRT_API_BASEPATH}/affiliation-awin/ref?awc=${awc}`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            )

            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`)
            }
            return response.json()
        },
        {
            enabled: shouldFetch,
            retry: false,
        },
    )
}

export default useAwinRef
